import React from 'react';
import IntlMessageFormat from 'intl-messageformat';

import { useGlobalState } from '~src/main/context/global-state';

export type TranslateFn = (key: string, params?: any) => string;

export const LocalizationContext = React.createContext<Record<string, string> | undefined>(
  undefined
);

export function useTranslate() {
  const globalState = useGlobalState();
  const localization = React.useContext(LocalizationContext);

  if (localization === undefined) {
    return (key: string) => key;
  }

  return (key: string, params?: any) => {
    if (localization[key] === undefined) {
      console.error(`The localization for "${key}" does not exist`);
      return key;
    }

    if (params === undefined) {
      return localization[key];
    }

    return new IntlMessageFormat(localization[key], globalState.locale).format(params) as string;
  };
}
